import type { GVariantBadgeProps } from '~/presentation/ui';
import type { Variant } from '~/modules/campaign/types';

import { GVariantBadgeType } from '~/presentation/ui';

export const parseVariantBadge = (
  variant?: Pick<Variant, 'isOrigin' | 'isWinner'>,
): GVariantBadgeProps => {
  if (variant?.isOrigin)
    return { label: 'Control', variant: 'A', tone: 'active', isShowWinner: variant?.isWinner };

  return { label: 'Variant', variant: 'B', isShowWinner: variant?.isWinner };
};

export const parseVariantBadgeByType = (type: GVariantBadgeType): GVariantBadgeProps => {
  switch (type) {
    case GVariantBadgeType.ORIGIN:
      return { label: 'Control', variant: 'A', tone: 'active' };
    case GVariantBadgeType.VARIANT_B:
      return { label: 'Variant', variant: 'B' };
    case GVariantBadgeType.VARIANT_C:
      return { label: 'Variant', variant: 'C' };
    case GVariantBadgeType.VARIANT_D:
      return { label: 'Variant', variant: 'D' };
    case GVariantBadgeType.VARIANT_E:
      return { label: 'Variant', variant: 'E' };
  }
};
